<template>
    <div class="container mt-nav z-index">
        <Head title="عضویت" />
        <div class="row">
            <div class="col-sm-10 col-lg-6  mx-auto">
                <div class="box__information">
                    <div class="col-12 col-md-10">
                        <p class="text-title text-white text-center pb-3">جهت تکمیل عضویت فرم را تکمیل کنید</p>
                        <form @submit.prevent="store">
                            <text-input ref="firstName" v-model="form.firstName" :error="form.errors.firstName" class="my-3" placeHolder="نام" />
                            <text-input  v-model="form.lastName" :error="form.errors.lastName" class="my-3" placeHolder="نام خانوادگی" />
                            <template v-if="showMobileInput">
                                <text-input  dir="ltr" v-model="form.mobile" :error="form.errors.mobile" class="my-3" placeHolder="شماره موبایل" />
                            </template>
                            <template v-else>
                                <span class="m-0 text-sm text-white">  در صورتی که میخواهید کلمه عبور را تغییر دهید قسمت کلمه عبور را وارد کنید</span>

                            </template>
                            <text-input  dir="ltr" type="password" v-model="form.password" :error="form.errors.password" class="my-3" placeHolder=" کلمه عبور" />
                            <text-input  dir="ltr" type="password" v-model="form.repeat_password" :error="form.errors.repeat_password" class="my-3" placeHolder="تکرار کلمه عبور" />
                            <template v-if="showMobileInput">
                            <div class="mt-5">
                                <Link  class=" m-0 text-sm text-white" href="/login">قبلا عضو شده ام  (ورود به پروفایل)</Link>
                            </div>
                            </template>
                            <div class="mt-5 text-center">
                                <loading-button :loading="form.processing" class="tn border-0 btn-orange w-100-btn" type="submit">{{inputFormText}}</loading-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { Head } from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "../../Shared/Layouts/LayoutFirstRegister";
import { Link } from "@inertiajs/inertia-vue3";
import TextInput from "../../Shared/Forms/TextInput";
import LoadingButton from "../../Shared/Layouts/LoadingButton";

export default {
    props : ['name','logined','auth'],
    components: {
        TextInput,
        Link,
        LoadingButton,
        Head,
    },
    layout: LayoutFirstRegister,
    data() {
        return {
            showMobileInput : true,
            inputFormText : 'عضویت',
            formAction : '/register',
            form: this.$inertia.form({
                firstName: '',
                lastName: '',
                mobile: '',
                password: '',
                repeat_password: '',
            }),
        }
    },
    methods: {
        store() {
            this.form.post(this.formAction , {
                onSuccess: (data) => {
                }
            })
        },
    },
    updated() {
        if (this.logined) {
            window.location.href = 'profile';
        }
    },
    mounted() {
        if (this.auth.user){
            this.formAction = '/edit_profile';
            this.showMobileInput = false;
            this.inputFormText = 'ویرایش پروفایل';
            this.form.firstName = this.auth.user.first_name;
            this.form.lastName = this.auth.user.last_name;
        }
        this.$refs.firstName.focus();
    },
    metaInfo() {
        return {
            meta : [
                {name : 'description' , content : 'hello is my desd'}
            ]
        }

    }
}

</script>

<style scoped>

</style>
